document.addEventListener('rdstation-form-loaded', function(event) {
  const inputs = document.querySelectorAll(`#form-${event.detail.formId} input[type="email"][placeholder*="corporativo"]`);
  controllerInputs(inputs);
});

document.addEventListener('DOMContentLoaded', function() {
  const inputs = getCorporateEmailInputs();
  controllerInputs(inputs);
});

function controllerInputs(inputs) {
  const handledForms = new WeakSet();

  inputs.forEach(function(input) {
    const form = input?.closest('form');

    if (!form) {
      return;
    }

    const errorEl = document.createElement('span');
    errorEl.className = 'email-error';

    input.insertAdjacentElement('afterend', errorEl);

    input.addEventListener('input', function() {
      errorEl.textContent = '';
      errorEl.classList.remove('active')
    });

    input.addEventListener('blur', function() {
      errorEl.textContent = validateCorporateEmail(input.value);

      if(errorEl.textContent) {
        errorEl.classList.add('active')
      }
    });

    input.addEventListener('change', function() {
      errorEl.textContent = validateCorporateEmail(input.value);

      if(errorEl.textContent) {
        errorEl.classList.add('active')
      }
    });

    if (!handledForms.has(form)) {
      form.addEventListener('submit', function(e) {
        const emailInputs = form.querySelectorAll('input[type="email"][placeholder*="corporativo"]');
        let hasError = false;

        emailInputs.forEach(function(input) {
          const errorEl = input.nextElementSibling;
          const error = validateCorporateEmail(input.value);
          errorEl.textContent = error;
          if (error) hasError = true;
        });

        if (hasError) e.preventDefault();
      });

      handledForms.add(form);
    }
  });
}

function validateCorporateEmail(emailRaw) {
  const email = emailRaw.trim();
  if (!email) return '';

  const emailRegex = /^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
  if (!emailRegex.test(email)) return 'Por favor, insira um email corporativo válido.';

  const domain = email.split('@')[1].toLowerCase();
  const personalDomains = new Set([
    'gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com.br',
    'yahoo.com', 'uol.com.br', 'bol.com.br', 'ig.com.br',
    'terra.com.br'
  ]);

  return personalDomains.has(domain)
    ? 'Por favor, use um email corporativo.'
    : '';
}

function getCorporateEmailInputs() {
  const labels = document.querySelectorAll('label');

  const corporativoLabels = Array.from(labels).filter(label =>
    label.textContent.includes('Corporativo')
  );

  return corporativoLabels.map(label => {
    const input = label.parentElement.querySelector('input[type="email"]')

    if(!input) {
      return;
    }

    return input;
  });
}
